import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n    @media only screen and (max-width: ', 'px) {\n      ', ';\n    }\n  '], ['\n    @media only screen and (max-width: ', 'px) {\n      ', ';\n    }\n  ']);

import { css } from 'styled-components';

var breakpoints = {
  phone: 480,
  'phone-wide': 600,
  tablet: 768,
  'tablet-wide': 944,
  desktop: 1264,
  'desktop-wide': 1900

  // Iterate through the sizes and create a media template
};var media = Object.keys(breakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return css(_templateObject, breakpoints[label], css.apply(undefined, arguments));
  };

  return acc;
}, {});

export default media;
//# sourceMappingURL=media.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/styles/media.js
// module id = 420
// module chunks = 0